import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { CoreServiceRegistry } from '../../../../../core/core-service-registry';
import { DoorAddBookingDetailPopupComponent } from '../../../../../shared/lookup/dock-door-booking-popups/door-add-booking-detail-popup/door-add-booking-detail-popup.component';
import { DoorBlockingPopupComponent } from '../../../../../shared/lookup/dock-door-booking-popups/door-blocking-popup/door-blocking-popup.component';
import { DoorSchedulePopupComponent } from '../../../../../shared/lookup/dock-door-booking-popups/door-schedule-popup/door-schedule-popup.component';
import { GenerateBookingPopupComponent } from '../../../../../shared/lookup/dock-door-booking-popups/generate-booking-popup/generate-booking-popup.component';
import { DetailedEntityActionService } from '../../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-action.service';
import { SharedServiceRegistry } from '../../../../../shared/shared-service-registry';
import { DockDoorBookingBackendService } from './dock-door-booking-backend.service';
import { DockDoorBookingDataEditorService } from './dock-door-booking-data-editor.service';
import { DockDoorBookingDataService } from './dock-door-booking-data.service';
import { DockDoorBookingKeyEventHandlerService } from './dock-door-booking-key-event-handler.service';
import { DockDoorBookingSearchService } from './dock-door-booking-search.service';
import { DDB_CONSTANTS } from '../../../../../constants';

@Injectable()
export class DockDoorBookingActionService extends DetailedEntityActionService {

  public backendService: DockDoorBookingBackendService;
  protected dataService: DockDoorBookingDataService;
  protected dataEditor: DockDoorBookingDataEditorService;
  public tableIds: any;
  public finalDuration:any;
  public validBookingDt = true;
  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }
  // Method used to edit the Entity detail page
  public editPage() {
    this.dataService.setOriginalDataMap();
    // this.dataEditor.populateDropdownValuesBasedOnStorerInAccordion();
    // this.dataEditor.populateDropdownValuesBasedOnStorerInTables();
    this.dataEditor.populateDoorValuesBasedOnFacilityInAccordion();
    if (this.dataService.displayMode === 'V') {
      this.dataService.setDisplayMode('E');
      this.buttonService.initializeButtons(this.dataService.primaryDataMap);
      // LFWM-3634- overriding metadataMap as some of the fields need to be editable even after finanlizing.
      this.dataService.overrideMetadataMap('E');
    } else if (this.dataService.displayMode === 'E') {
      this.dataService.setDisplayMode('V');
      this.buttonService.initializeButtons(this.dataService.primaryDataMap);
      this.clearEditedFlags();
    }
  }

  public fetchColorData() {
    this.backendService.fetchColorData(['BKORDSTATO', 'BkStatusO'])
      .subscribe((response: any) => {
        for (let key in response['statusColorMap']) {
          this.dataService.statusColorDataMap[key] = {};
          response['statusColorMap'][key].forEach(obj => {
            if (obj.shortDesc) {
              this.dataService.statusColorDataMap[key][key == 'BKORDSTATO' ? obj.description : obj.code] = {
                color: obj.shortDesc.toLowerCase(),
                displayText: obj.description
              };
            }
          });
        }
        //Adding color data map for calendar month mode.
        this.dataService.statusColorDataMap['BkSlotStat'] = {
          A: {
            color: 'green',
            displayText: 'Available'
          },
          L: {
            color: 'orange',
            displayText: 'Low'
          },
          F: {
            color: 'red',
            displayText: 'Full'
          },
          R: {
            color: 'purple',
            displayText: 'Reservation'
          },
        };
      });
  }

  public fetchDoors(data: any): Observable<any> {
    return this.backendService.fetchDoors(data);
  }

  handleAddBookingDetails(facility: string) {
    const modalRef: any = this.sharedServiceRegistry.sceModalService
      .showModal(DoorAddBookingDetailPopupComponent,
        {
          overlayHeader: this.resourceService.get('lbl_add_booking_dtl'),
          showHeader: true,
          overlayHeight: 512,
          overlayWidth: 812
        });
    if (this.tableIds === 'ddbookintd') {
      modalRef.content.initializeComponents1(facility, this.dataEditor);
    }
    if (this.tableIds === 'ddbooktd') {
      modalRef.content.initializeComponents(facility, this.dataEditor);
    }
    modalRef.content.receiveEvent().subscribe(event => {
      this.dataService.addedShipmentGIds = [];
      if (event.type == 'add' && event.data && event.data.length > 0) {
        const detailsSearchService = this.dataService.getDetailsSearchService() as DockDoorBookingSearchService;
        event.data.forEach((row: any) => {
          detailsSearchService.addNewRowToModelWithData(row);
          this.dataService.addedShipmentGIds.push(row.cells['shipmentGID'].cVal);
        });
        this.buttonService.performButtonActions('Save');
      }
    });
  }

  handleCalendarClick(data: any) {
    if (data.ioIndicator === 'IN') {
      this.dataService.sendShowDetailsPageEvent({
        id: data.bookingId,
        isCreateItem: false,
      });
      this.tableIds = 'ddbookintd';
    } else if (data.ioIndicator === 'OUT') {
      this.dataService.sendShowDetailsPageEvent({
        id: data.bookingId,
        isCreateItem: false,
      });
      this.tableIds = 'ddbooktd';
    } else {
      const modalRef: any = this.sharedServiceRegistry.sceModalService
        .showModal(DoorSchedulePopupComponent,
          {
            overlayHeader: this.resourceService.get(data.blockingId ? 'lbl_schedule_block' : 'label_Schedule'),
            showHeader: true,
            overlayHeight: 380,
            overlayWidth: 565
          });
      modalRef.content.initializeComponents(this.dataService, data);
      modalRef.content.receiveEvent().subscribe(event => {
       const refreshEventCheck = event.type === DDB_CONSTANTS.REFRESH_EVENT && this.dataService.primarySearchServiceObj[DDB_CONSTANTS.SCHEDULE_BY_DAY_TD];
        if (refreshEventCheck) {
          this.dataService.primarySearchServiceObj[DDB_CONSTANTS.SCHEDULE_BY_DAY_TD].performSearch();
        } else if (event.type === DDB_CONSTANTS.INBOUND_EVENT) {
          const bayTypeCheck = data.fromDoorType === DDB_CONSTANTS.BAY_OUT || data.toDoorType === DDB_CONSTANTS.BAY_OUT;
          if (bayTypeCheck) {
            this.confirmDialogService.confirmDialog(this.getConfirmMessage(DDB_CONSTANTS.BAY_OUT, DDB_CONSTANTS.INBOUND)).subscribe((confirmed) => {
              if (confirmed) {
                this.navigateToDetailsPage(DDB_CONSTANTS.INBOUND_TD);
              }
            });
          } else {
            this.navigateToDetailsPage(DDB_CONSTANTS.INBOUND_TD);
          }
        } else if (event.type === DDB_CONSTANTS.OUTBOUND_EVENT) {
          const bayTypeCheck = data.fromDoorType === DDB_CONSTANTS.BAY_IN || data.toDoorType === DDB_CONSTANTS.BAY_IN;
          if (bayTypeCheck) {
            this.confirmDialogService.confirmDialog(this.getConfirmMessage(DDB_CONSTANTS.BAY_IN, DDB_CONSTANTS.OUTBOUND)).subscribe((confirmed) => {
              if (confirmed) {
                this.navigateToDetailsPage(DDB_CONSTANTS.OUTBOUND_TD);
              }
            });
          } else {
            this.navigateToDetailsPage(DDB_CONSTANTS.OUTBOUND_TD);
          }
        } else if (event.type === DDB_CONSTANTS.BLOCK_EVENT) {
          this.blockDoor(event.data);
        }
      });
    }
  }

  /**
   * Builds a confirmation prompt based on the current door configuration and intended action.
   * @param doorType The type of door currently assigned to the location.
   * @param actionType The booking action the user intends to perform.
   * @returns A formatted confirmation message presented to the user.
   */
  getConfirmMessage(doorType: string, actionType: string) {
    return `This location is currently marked as ${doorType}. Are you sure you want to book it for ${actionType}?`;
  }
  /**
   * Navigates to the details page for creating a new booking item for the specified table.
   * @param tableId Identifier representing the table context to open in the details view.
   */
  navigateToDetailsPage(tableId: string) {
    this.dataService.sendShowDetailsPageEvent({
      isCreateItem: true
    });
    this.tableIds = tableId;
  }
  blockDoor(data: any) {
    const modalRef: any = this.sharedServiceRegistry.sceModalService
      .showModal(DoorBlockingPopupComponent,
        {
          overlayHeader: this.resourceService.get("lbl_door_blocking"),
          showHeader: true,
          overlayHeight: 520,
          overlayWidth: 512
        });
    const keyEventHandler = new DockDoorBookingKeyEventHandlerService(this.dataEditor);
    modalRef.content.initializeComponents(keyEventHandler, data);
    modalRef.content.receiveEvent().subscribe(event => {
      if (event.type === 'refresh' && this.dataService.primarySearchServiceObj['ddschedulebydaytd']) {
        this.dataService.primarySearchServiceObj['ddschedulebydaytd'].performSearch();
      }
    });
  }

  /*This method forms the request for saving the entity details. While editing an existing entity,
  the original data should also be sent prefixed with _original, along with the edited data
  If it is a new entity the prefix can be avoided*/
  public getEntityValuesList() {
    let data;
    const accordionDetails = [];
    const typeName = 'original_';
    const primaryDataMap = this.convertedPrimaryDataMap();
    Object.keys(primaryDataMap).forEach((property: any) => {
      data = primaryDataMap[property];
      if (this.dataService.displayMode === 'E') {
        if (data.isEdited) {// for fields which are edited
          /*LFWM-1733 this.dataService.originalDataMap[property].cVal will give the original value
          of that particular field, cValPrev will give the previosly modified value and
          not the original value.The original value should also be send along with the req */
          // LFWM-1761 : Code fix
          // [LFWM-2408] - no need to send addwho and editWho this will be added at backend
          if (property.toLowerCase() === 'addwho' || property.toLowerCase() === 'editwho') {
            return false;
          } else {
            accordionDetails.push({ cName: typeName + data.cName, cVal: data.cValPrev });
            accordionDetails.push({ cName: data.cName, cVal: data.cVal });
          }
        } else {
          if (!(this.dataService.primaryMetaDataMap[data.cName] &&
            (this.dataService.primaryMetaDataMap[data.cName].displayType === 'H') && (data.cVal === null || data.cVal === undefined))) {
            // [LFWM-2408] - no need to send addwho and editWho this will be added at backend
            if (property.toLowerCase() === 'addwho' || property.toLowerCase() === 'editwho') {
              return false;
            } else {
              accordionDetails.push({ cName: typeName + data.cName, cVal: data.cVal });
              accordionDetails.push({ cName: data.cName, cVal: data.cVal });
            }
          }
        }
      } else { // for new entity
        accordionDetails.push({ cName: data.cName, cVal: data.cVal });
      }
    });
    if (this.dataService.displayMode === 'C') {
      accordionDetails.push({ cName: 'isNewItem', cVal: true });
    }
    return accordionDetails;
  }

  convertedPrimaryDataMap() {
    let primaryDataMap = JSON.parse(JSON.stringify(this.dataService.primaryDataMap));
    if (primaryDataMap['fromBookingTime'].isEdited) {
      primaryDataMap['bookingDate'].isEdited = true;
      primaryDataMap['duration'].isEdited = true;
    }
    if (primaryDataMap['bookingTime'] && primaryDataMap['bookingTime'].isEdited) {
      primaryDataMap['duration'].isEdited = true;
    }
    if (this.tableIds === 'ddbooktd') {
      if (primaryDataMap['callTime'].isEdited && primaryDataMap['callTime'].cVal) {
        primaryDataMap['callTime'].cVal = this.fixTimeZoneOffset(new Date(primaryDataMap['callTime'].cVal));
      }
    }
    if (this.tableIds !== 'ddbookintd') {
      // primaryDataMap['bookingDate'].cVal =
      //   this.getConvertedDateTime(this.dataService.primaryDataMap['bookingDate'].cVal,
      //     this.dataService.primaryDataMap['fromBookingTime'].cVal);
      // primaryDataMap['bookingTime'].cVal =
      //   this.getConvertedDateTime(this.dataService.primaryDataMap['bookingDate'].cVal,
      //     this.dataService.primaryDataMap['bookingTime'].cVal);
      // primaryDataMap['bookingDate'].cValPrev =
      //   this.getConvertedDateTime(this.dataService.primaryDataMap['bookingDate'].cValPrev || this.dataService.primaryDataMap['bookingDate'].cVal,
      //     this.dataService.primaryDataMap['fromBookingTime'].cValPrev || this.dataService.primaryDataMap['fromBookingTime'].cVal);
      // primaryDataMap['bookingTime'].cValPrev =
      //   this.getConvertedDateTime(this.dataService.primaryDataMap['bookingDate'].cValPrev || this.dataService.primaryDataMap['bookingDate'].cVal,
      //     this.dataService.primaryDataMap['bookingTime'].cValPrev || this.dataService.primaryDataMap['bookingTime'].cVal);
    }
    // if (this.tableIds !== 'ddbooktd') {
      if(this.dataService.primaryDataMap['bookingDate'] && this.dataService.primaryDataMap['bookingDate'].cVal){
        this.dataService.primaryDataMap['bookingDate'].cVal = moment(this.dataService.primaryDataMap['bookingDate'].cVal).format('YYYY-MM-DD HH:mm:ss.SSS')
      }
      //LFWM-4874- Date conversion logic modified for new end date
      let bookinDtSplit = primaryDataMap['bookingDate'].cVal.split(' ');
      let bookinDtEndSplit = primaryDataMap['bookingTime'].cVal.split(' ');
      let durationSplit = this.finalDuration.split(' ');
      primaryDataMap['bookingDate'].cVal =
        this.getConvertedDateTime(bookinDtSplit[0],
          bookinDtSplit[1]);
      primaryDataMap['bookingTime'].cVal =
        this.getConvertedDateTime(bookinDtEndSplit[0],
          bookinDtEndSplit[1]);
      this.finalDuration = this.getConvertedDateTime(durationSplit[0],
        durationSplit[1]);

      primaryDataMap['duration'].cValPrev = primaryDataMap['duration'].cVal;
      const duration = new Date(primaryDataMap['bookingTime'].cVal - primaryDataMap['bookingDate'].cVal);
      //Starting year should be 1900 instead of 1970(default).
      duration.setUTCFullYear(duration.getUTCFullYear() - 70);
      primaryDataMap['duration'].cVal = this.finalDuration;
    // }
    delete primaryDataMap['fromBookingTime'];
    return primaryDataMap;
  }

  getConvertedDateTime(date: Date, time: string, fixTimeZone = true) {
    if (!date) {
      return date;
    }
    if (!time) {
      return time;
    }
    let times = time.split(':');
    date = new Date(date);
    date.setHours(+times[0], +times[1], 0, 0);
    if (fixTimeZone) {
      return this.fixTimeZoneOffset(date);
    } else {
      return date;
    }
  }

  fixTimeZoneOffset(date: Date) {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
  }

  mapShipmentGIds(): Observable<Response> {
    return this.backendService.mapShipmentGIds(this.dataService.getPrimarySelectedDocument(), this.dataService.addedShipmentGIds, this.getShipmentType());
  }

  /**
   * this method is use to refresh the accordion after populate po button action
   */
  // [LFWM_2580]- added refreshAccordion to reload the page after save.
  public refreshAccordion() {
    const primarySearchService = this.dataService.primarySearchService;
    primarySearchService
      .getItemDetailForId(primarySearchService.searchParams.idProperty, this.dataService.getPrimarySelectedDocument())
      .subscribe((response: any) => {
        if (!response || !response.cells) {
          this.alertService.error(this.resourceService.get('msg_reload_failure'));
          return;
        }
        response.cells.forEach((cell: any) => {
          cell.isEdited = false;
          this.dataService.primaryDataMap[cell.cName] = cell;
        });
        if (this.dataService.primarySearchParams.tableId === 'ddbooktd' || this.dataService.primarySearchParams.tableId === 'ddbookintd' ) {
          if (this.dataService.primaryDataMap['fromBookingTime'].cVal) {
            let time = moment(this.dataService.primaryDataMap['fromBookingTime'].cVal);
            this.dataService.primaryDataMap['fromBookingTime'].cVal = time.format('HH:mm');
          }
          if (this.dataService.primaryDataMap['bookingTime'] && this.dataService.primaryDataMap['bookingTime'].cVal) {
            let time = moment(this.dataService.primaryDataMap['bookingTime'].cVal);
            // if(this.dataService.primarySearchParams.tableId === 'ddbooktd')
            //   this.dataService.primaryDataMap['bookingTime'].cVal = time.format('HH:mm');
          }
        }
        this.buttonService.initializeDetailPageButtons(this.dataService.primaryDataMap);
      });
  }

  finalize() {
    this.backendService.finalize(this.dataService.getPrimarySelectedDocument()).subscribe((response: any) => {
      if (response.statusCode === 200 && response.statusMessage === "SUCCESS") {
        this.dataService.getDetailsSearchService().clearMarkerFlags();
        this.dataService.setDisplayMode('V');
        this.refreshAccordion();
        this.buttonService.initializeButtons(this.dataService.getPrimaryDataMap());
        this.alertService.clearAll().success(this.resourceService.get('msg_fin_succ').replace('{} ', ''));
      } else {
        this.alertService.clearAll().error(this.resourceService.get(response.statusMessage));
      }
    }, error => {
      this.alertService.clearAll().error(this.resourceService.get(error));
    });;
  }
  // LFWM-3481- popup for both the buttons are same.
  // In item variable, the corresponding function name is send from button service.
  public generateAppointmentAndBooking(item: any) {
    const modalRef: any = this.sharedServiceRegistry.sceModalService
      .showModal(GenerateBookingPopupComponent,
        {
          overlayHeader: null,
          showHeader: false,
          overlayHeight: 250,
          overlayWidth: 512
        });
    modalRef.content.initializeComponents(item);
    modalRef.content.receiveEvent().subscribe(event => {
      if (event.type === 'generateAppointment') {
        this.generateAppointment();
      } else {
        this.generateBooking();
      }
    });
  }
  // LFWM-3481-generate appointment functionality.
  public generateAppointment() {
    let errorMessage: any[] = [];
    let storerKey = this.dataService.searchDataMap.summary['storerKey'];
    let facility = this.dataService.searchDataMap.summary['facility'];
    // LFWM-3481-StorerKey and facility must have a value.
    if (this.validateStorekeyFacility(storerKey, facility)) {
      this.backendService.generateAppointment(storerKey, facility).subscribe((response: any) => {
        if (response.statusCode === 200 && response.statusMessage === "SUCCESS") {
          this.dataService.getPrimarySearchService().performSearch();
          this.alertService.clearAll().success(this.resourceService.get('msg_appointment_gen_success'));
        } else {
          response.errors.forEach(error => {
            errorMessage.push(this.resourceService.get(error.errorKey));
          });
          this.alertService.clearAll().error(errorMessage);
        }
      }, error => {
        this.alertService.clearAll().error(this.resourceService.get(error));
      });
    }
  }
  // LFWM-3481-generate booking functionality.
  public generateBooking() {
    let errorMessage: any[] = [];
    let storerKey = this.dataService.searchDataMap.summary['storerKey'];
    let facility = this.dataService.searchDataMap.summary['facility'];
    // LFWM-3481-StorerKey and facility must have a value.
    if (this.validateStorekeyFacility(storerKey, facility)) {
      this.backendService.generateBooking(storerKey, facility).subscribe((response: any) => {
        if (response.statusCode === 200 && response.statusMessage === "SUCCESS") {
          this.dataService.getPrimarySearchService().performSearch();
          this.alertService.clearAll().success(this.resourceService.get('msg_booking_gen_success'));
        } else {
          response.errors.forEach(error => {
            errorMessage.push(this.resourceService.get(error.errorKey));
          });
          this.alertService.clearAll().error(errorMessage);
        }
      }, error => {
        this.alertService.clearAll().error(this.resourceService.get(error));
      });
    }
  }
  public validateStorekeyFacility(storerKey: any, facility: any) {
    // LFWM-3481-StorerKey and facility must have a value.
    if (storerKey === '*' || storerKey === '' || storerKey === null) {
      this.alertService.clearAll().error(this.resourceService.get('msg_entr_storerkey_val'));
    } else if (facility === '*' || facility === '' || facility === null) {
      this.alertService.clearAll().error(this.resourceService.get('msg_entr_facility_val'));
    }
    else {
      return true;
    }
  }

  /* LFWM-3531 Validation for LineItems - Vehicle Number */
  public validateLineItems(lineItems) {
    const reqValidationMap = {
      vehicleNo: "vehicle_no_validation"
    };
    for (let key of Object.keys(reqValidationMap)) {
      if (lineItems.some(lineItem => lineItem.cells.some(property => property.cName === key && !property.cVal))) {
        return this.resourceService.get(reqValidationMap[key]);
      }
    }
    return null;
  }

  public getStorerByBookingNo(tableId:string, bookingNo: string) {
    return this.backendService.getStorerByBookingNo(tableId, bookingNo);
  }

  // LFWM-3634-validating the slot availability.
  public validateSlotAndBay() {
    const primaryDataMap = this.convertedPrimaryDataMap();
    let fromDoors = this.dataService.primaryDataMap['fromDoor'].cVal;
    if (this.tableIds === 'ddbookintd') {
      var toDoors = null;
    }
    if (this.tableIds === 'ddbooktd') {
      var toDoors = this.dataService.primaryDataMap['toDoor'].cVal;
    }
    let bookingDates = primaryDataMap['bookingDate'].cVal;
    let bookingTimes = primaryDataMap['bookingTime'].cVal;
    let bookingNos = this.dataService.primaryDataMap['bookingNo'].cVal;
    let request = {
      'fromDoor': fromDoors,
      'toDoor': toDoors,
      'bookingDate': bookingDates,
      'bookingTime': bookingTimes,
      'bookingNo': bookingNos,
      'tableId': this.tableIds
    };
    return this.backendService.validateSlotAndBay(request);
  }

  public getShipmentType() {
    if (this.tableIds === 'ddbookintd') {
      return "inbound";
    }
    if (this.tableIds === 'ddbooktd') {
      return "outbound";
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/outbound/dock-door-booking/dock-door-booking-home/services/dock-door-booking-action.service.ts